import React, { useState } from 'react';

const PROBLEM_OPTIONS = [
  { value: 'It misunderstood my question', label: 'It misunderstood my question' },
  { value: 'The answer is incorrect', label: 'The answer is incorrect' },
  { value: 'It gave a confusing response', label: 'It gave a confusing response' },
  { value: 'other', label: 'Other' },
];

const ReportModal = ({ open, onClose, setSelectedIssue, handleReportIssue, selectedIssue, isReportLoading }: any) => {
  const [selectedOption, setSelectedOption] = useState('')

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/70">
      <div className="bg-white dark:bg-black dark:text-white w-full md:max-w-md rounded-2xl shadow-xl dark:shadow-[0_0_0_1px_rgba(255,255,255,0.2),0_25px_50px_-12px_rgba(255,255,255,0.15)] p-4 relative max-w-[95%] md:min-w-[700px] text-primary-default">
        <button
          onClick={() => {
            onClose()
            setSelectedOption('')
          }}
          className="absolute right-5 top-5 text-gray-400 hover:text-gray-700 text-2xl font-semibold"
          aria-label="Close"
        >
          <img alt='thumb up' src={'/svg/icons/close.svg'} className='object-contain w-[22px] contrast-0' />
        </button>
        <div className="mb-6">
          <h2 className="text-xl md:text-2xl font-semibold mb-1">What&apos;s the problem</h2>
          <p className="text-gray-700 text-sm md:text-base mb-3">Please select one</p>
          <div className="space-y-2 md:space-y-3">
            {PROBLEM_OPTIONS.map((opt) => (
              <label
                key={opt.value}
                className="flex items-center cursor-pointer gap-2 text-sm"
              >
                <input
                  type="radio"
                  name="problem"
                  value={opt.value}
                  checked={selectedIssue === opt.value || selectedOption === opt.value}
                  onChange={() => {
                    setSelectedOption(opt.value)
                    if(opt.value !== 'other'){
                      setSelectedIssue(opt.value)
                    }else{
                      setSelectedIssue('')
                    }
                  }}
                  className="h-4 w-4 accent-black"
                />
                <span className="text-base">{opt.label}</span>
              </label>
            ))}
          </div>
          {selectedOption === 'other' && (
            <textarea
              className="mt-4 w-full rounded-lg border border-gray-200 pl-2 pt-1 min-h-[100px] focus:outline-none focus:ring-2 focus:ring-gray-300 text-base resize-none bg-[#F5F5F5]"
              placeholder="Please describe the issue"
              value={selectedIssue}
              onChange={e => setSelectedIssue(e.target.value)}
              maxLength={1000}
            />
          )}
        </div>
       <div className='w-full flex justify-end'>
         <button
            className={`w-[50%] py-2 bg-[#252B37] text-white rounded-[6px] text-base  hover:bg-gray-800 transition ${!selectedIssue ? 'opacity-50' : ''}`}
            onClick={() => {handleReportIssue(); setSelectedOption('')}}
            disabled={!selectedIssue}
            >
            <p className="font-inter font-normal text-white text-base">{isReportLoading ? 'Submitting...' : 'Report Issue'}</p>
          </button>
       </div>
      </div>
    </div>
  );
}


export default ReportModal